var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.1,98.84H1.11c-.55,0-1-.45-1-1v-24.92c0-.55.45-1,1-1h17.09c.27,0,.53.11.71.3l8.69,8.85h44.01l8.69-8.85c.19-.19.45-.3.71-.3h17.09c.55,0,1,.45,1,1v24.92c0,.55-.45,1-1,1ZM2.11,96.84h94.99v-22.92h-15.67l-8.69,8.85c-.19.19-.45.3-.71.3H27.18c-.27,0-.53-.11-.71-.3l-8.69-8.85H2.11v22.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.98,63.81c-.24,0-.47-.08-.66-.25l-25.1-21.98c-.31-.27-.42-.71-.28-1.1.15-.39.52-.65.94-.65h10.71V1.79c0-.55.45-1,1-1h27.48c.55,0,1,.45,1,1v38.04h10.01c.42,0,.79.26.94.65.15.39.04.83-.28,1.1l-25.1,21.98c-.19.17-.42.25-.66.25ZM26.54,41.83l22.44,19.66,22.44-19.66h-8.35c-.55,0-1-.45-1-1V2.79h-25.48v38.04c0,.55-.45,1-1,1h-9.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.f69d6413592e0d302a30f9f7d1929ec1.svg";
export { ForwardRef as ReactComponent };